import React, {ReactNode, useRef} from 'react';
import {Layout} from 'antd';
import Header from '../Header/component';
import SideBar from '../SideBar/component';
import SubscriptionModal from '../Modals/subscription/component';

const {Content} = Layout;

interface MainLayoutProps {
    children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({children}) => {
    const openSidebarRef = useRef<null | (() => void)>(null);

    return (
        <Layout style={{minHeight: '100vh', overflow: 'auto'}}>
            <Header onOpenSidebar={() => openSidebarRef.current?.()}/>

            <Layout>
                <SideBar
                    renderMobileTrigger={(open) => {
                        openSidebarRef.current = open;
                        return null;
                    }}
                />

                <Content style={{margin: '0 16px'}}>
                    {children}
                    <SubscriptionModal/>
                </Content>
            </Layout>
        </Layout>
    );
};

export default MainLayout;
